var React = require('react');

function IconAim (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M22.753 11.909a9.812 9.812 0 0 0-8.662-8.662V1h-2.182v2.247a9.812 9.812 0 0 0-8.662 8.662H1v2.182h2.247a9.812 9.812 0 0 0 8.662 8.662V25h2.182v-2.247a9.812 9.812 0 0 0 8.662-8.662H25v-2.182zM13 20.636A7.636 7.636 0 1 1 20.636 13 7.631 7.631 0 0 1 13 20.636z","transform":"translate(-1 -1)"}));
}

IconAim.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconAim;

IconAim.default = IconAim;
